import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const saveTableSettingsToStoreAction = createAction(ACTIONS.SAVE_TABLE_SETTINGS_TO_STORE)<{
  tableId: string;
  tableName: string;
  gameId: string | null;
  dealerNickname: string;
  minBetLimit: number;
  maxBetLimit: number;
  displayingWinBall: number;
}>();

export const updateGameIdAction = createAction(ACTIONS.UDATE_GAME_ID)<{ gameId: string }>();

export const updateDealerAction = createAction(ACTIONS.UPDATE_DEALER)<{ dealerNickname: string }>();
